// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"350":"776f8194","542":"67043d5f","566":"7c307e13","640":"52d05926","960":"cfc644c7"}[chunkId] + ".chunk.css";
};